export const fetchCategoryList = ({
  page = 1,
  perPage = 10,
  search = '',
  populate,
} = {}) => {   
  let queryString = `page=${page}&perPage=${perPage}&search=${search}`
  if (populate) queryString += `&populate=${populate}`
  
  return ({
    method: 'GET',
    endpoint: `/categories?${queryString}`
  })
};
